module.exports = __webpack_public_path__ + "static/media/coin.249254d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coin.png
// module id = 144
// module chunks = 0